import styled from "styled-components"

export const LogoWrap = styled.div`
  text-decoration: none;
  margin: auto 0;
  flex: 0 1 36px;

  padding: 5px 3px 5px 13px;
  border-radius: 20%;

  @media (max-width: 30rem) {
    height: 1.875rem;
    width: 1.875rem;
  }
`
